@if (ngxConfig.showFooter && (!shouldShowMobileCards || !isMobileScreen)) {
  <div class="table-density">
    <div class="segmented-control" role="group" [attr.aria-label]="'words.tableDensity' | translate">
      <button type="button" [attr.aria-pressed]="isCompact" (click)="setCompact(true)">
        <i class="fa fa-compress"></i>
        {{ 'words.tableDensityCompact' | translate }}
      </button>
      <button type="button" [attr.aria-pressed]="!isCompact" (click)="setCompact(false)">
        <i class="fa fa-align-justify"></i>
        {{ 'words.tableDensityNormal' | translate }}
      </button>
    </div>
  </div>
}

@if (!shouldShowMobileCards || !isMobileScreen) {
  <ngx-datatable
    #ngxDatatable
    class="material"
    [class.is-compact]="isCompact"
    [id]="shouldApplyStickyHeader ? 'sticky-datatable' : ''"
    [rows]="isLoadingRows ? skeletonRows : data"
    [loadingIndicator]="false"
    [columnMode]="ngxConfig.columnMode"
    [selectionType]="ngxConfig.selectionType"
    [scrollbarH]="ngxConfig.scrollbarH"
    [rowHeight]="ngxConfig.rowHeight"
    [footerHeight]="1"
    [messages]="{ emptyMessage: ngxConfig.emptyMessage | translate }"
    [externalSorting]="ngxConfig.externalSorting"
    [sorts]="ngxConfig.sort ? [ngxConfig.sort] : []"
    (select)="emitOnSelectRow($event)"
    (sort)="emitOnSort($event)"
    (resize)="onColumnResize($event)">
    <!-- Columnas de la tabla -->
    @for (col of ngxConfig.columns; track $index) {
      @if (!col.isExpandable && !col.expandableCellTemplate && !col.expandableRowTemplate) {
        <ngx-datatable-column
          [name]="col.name || '' | translate"
          [prop]="col.prop || ''"
          [width]="col.width || 200"
          [headerClass]="(col.headerClass || '') + ' ngx-col-' + $index"
          [cellClass]="(col.cellClass || '') + ' ngx-col-' + $index"
          [sortable]="col.sortable || false"
          [frozenLeft]="col.frozenLeft || false"
          [frozenRight]="col.frozenRight || false"
          [cellTemplate]="isLoadingRows ? skeletonCell : (col.cellTemplate ?? undefined!)"
          ><ng-template
            let-row="row"
            let-value="value"
            let-column="col"
            ngx-datatable-cell-template>
            @if (row.isTotalRow) {
              <strong>
                {{ col.valueFormatter ? col.valueFormatter(value) : value }}
              </strong>
            } @else {
              <span>
                {{ col.valueFormatter ? col.valueFormatter(value) : value }}
              </span>
            }
          </ng-template>
        </ngx-datatable-column>
      }
      @if (col.isExpandable || col.expandableCellTemplate || col.expandableRowTemplate) {
        <!-- Template por defecto o personalizado para la columna con función expandible -->
        <ngx-datatable-column
          [name]="col.name || '' | translate"
          [width]="col.width || 75"
          [headerClass]="col.headerClass || ''"
          [cellClass]="col.cellClass || ''"
          [sortable]="col.sortable || false"
          [frozenLeft]="col.frozenLeft || false"
          [frozenRight]="col.frozenRight || false">
          <ng-template
            let-row="row"
            let-rowIndex="rowIndex"
            let-expanded="expanded"
            let-table="table"
            ngx-datatable-cell-template>
            @if (!row.isTotalRow && !isLoadingRows) {
              <ng-container
                *ngTemplateOutlet="
                  col.expandableCellTemplate ?? defaultExpandableCellTemplate;
                  context: { row, rowIndex, expanded, table: ngxDatatable }
                "></ng-container>
            }
          </ng-template>
        </ngx-datatable-column>

        <!-- Template por defecto o personalizado para la fila expandida -->
        <ngx-datatable-row-detail>
          <ng-template
            let-row="row"
            let-rowIndex="rowIndex"
            let-expanded="expanded"
            ngx-datatable-row-detail-template>
            <ng-container
              *ngTemplateOutlet="
                col.expandableRowTemplate ?? defaultExpandableRowTemplate;
                context: { row, rowIndex, expanded }
              "></ng-container>
          </ng-template>
        </ngx-datatable-row-detail>
      }
    }

    <!-- Footer de la tabla -->
    @if (ngxConfig.showFooter) {
      <ngx-datatable-footer>
        <ng-template ngx-datatable-footer-template>
          <div class="footer-left">
            <div class="page-size-container d-flex align-items-center gap-2">
              <span class="page-size-label">{{ 'words.showRows' | translate }}</span>
              <div
                class="segmented-control"
                role="group"
                [attr.aria-label]="'words.showRows' | translate">
                @for (option of ngxConfig.limitOptions; track $index) {
                  <button
                    type="button"
                    [attr.aria-pressed]="option.value == ngxConfig.limit"
                    (click)="emitOnChangeLimitFromMobile(option.value)">
                    {{ option.value }}
                  </button>
                }
              </div>
            </div>
            <div class="total-rows-container">
              <span>
                <b class="total-rows-count">{{ ngxConfig.count }}</b>
                {{ 'words.resultsLower' | translate }}
              </span>
            </div>
          </div>
          <datatable-pager
            [pagerLeftArrowIcon]="'datatable-icon-left'"
            [pagerRightArrowIcon]="'datatable-icon-right'"
            [pagerPreviousIcon]="'datatable-icon-prev'"
            [pagerNextIcon]="'datatable-icon-skip'"
            [page]="ngxConfig.page"
            [size]="ngxConfig.limit"
            [count]="ngxConfig.count"
            [hidden]="!(ngxConfig.count / ngxConfig.limit > 1)"
            (change)="emitOnChangePage($event)" />
        </ng-template>
      </ngx-datatable-footer>
    }
  </ngx-datatable>
}
@if (shouldShowMobileCards && isMobileScreen) {
  <div>
    <shared-tables-ngx-datatable-mobile-cards
      [data]="data"
      [config]="ngxConfig"
      [actions]="mobileActions"
      [cardTitleField]="mobileCardTitleField"
      [cardSubtitleField]="mobileCardSubtitleField"
      [isLoading]="isAutoLoading"
      (onSelectRow)="emitOnSelectRow($event)"
      (onChangeLimit)="emitOnChangeLimitFromMobile($event)"
      (onChangePage)="emitOnChangePageFromMobile($event)"
      (onButtonAction)="emitOnButtonAction($event)"></shared-tables-ngx-datatable-mobile-cards>
  </div>
}

<ng-template #skeletonCell>
  <span class="ngx-skeleton-cell">
    <span class="sc-skeleton ngx-skeleton-bar"></span>
  </span>
</ng-template>

<!-- Template por defecto para la columna con función expandible -->
<ng-template
  #defaultExpandableCellTemplate
  let-row="row"
  let-rowIndex="rowIndex"
  let-expanded="expanded"
  let-table="table">
  <div class="d-flex justify-content-end align-items-center gap-2">
    <a href="javascript:void(0)" title="Expand/Collapse Row" (click)="toggleExpandRow(table, row)">
      <i class="fa" [class.fa-chevron-right]="!expanded" [class.fa-chevron-down]="expanded"></i>
    </a>
  </div>
</ng-template>

<!-- Template por defecto para la fila expandida -->
<ng-template
  #defaultExpandableRowTemplate
  let-row="row"
  let-rowIndex="rowIndex"
  let-expanded="expanded">
  <span> Default expandable row template </span>
</ng-template>
